<template>
  <div class="home-main">
    <div class="home-main-text">
      <div
        class="transform-text"
        :class="{ 'newtransform-text': $t('lang') == 'de' }"
      >
        <p class="wow fadeInUp NexaBlack" data-wow-delay="0.5s">
          {{ $t("home.new") }}
        </p>
        <p class="wow fadeInUp" data-wow-delay="0.5s">
          {{ $t("home.gerenation") }}
        </p>
        <p class="wow fadeInUp NexaBlack" data-wow-delay="0.5s">
          {{ $t("home.oftendyev") }}
        </p>
      </div>
    </div>
    <div class="home-main-pic">
      <img
        src="@/assets/images/home-main.png"
        class="bg wow slideInLeft"
        data-wow-delay="1s"
        alt=""
      />
      <!-- <img src="@/assets/images/down.png" class="down" alt="" /> -->
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  mounted() {
    new WOW().init();
  },
};
</script>

<style lang="scss" scoped>
.home-main {
  display: flex;
  justify-content: space-between;
  background: #fff;
  .home-main-text {
    position: relative;
    width: 28%;
    // background: orange;
    // writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
    // writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
    .transform-text {
      position: absolute;
      bottom: 40%;
      left: 20%;
      font-size: 70px;
      line-height: 70px;
      text-align: left;
      color: #333;
      white-space: nowrap;
      transform: rotate(-90deg);
    }

    .newtransform-text {
      font-size: 52px;
    }
  }
  .home-main-pic {
    position: relative;
    width: 66%;
    overflow: hidden;
    .bg {
      width: 100%;
      height: 100%;
    }
    .down {
      position: absolute;
      bottom: 10%;
      left: 30%;
      width: 80px;
      // transform: rotate(90deg);
    }
  }
}
@media (max-width: 1450px) {
  .home-main {
    .home-main-text {
      position: relative;
      width: 28%;
      .transform-text {
        position: absolute;
        font-size: 54px;
        line-height: 54px;
      }
      .newtransform-text {
        font-size: 48px;
      }
    }
  }
}
@media (max-width: 1350px) {
  .home-main {
    .home-main-text {
      position: relative;
      width: 28%;
      .transform-text {
        position: absolute;
        font-size: 46px;
        line-height: 46px;
      }
      .newtransform-text {
        font-size: 42px;
      }
    }
  }
}
@media (max-width: 1200px) {
  .home-main {
    .home-main-text {
      position: relative;
      width: 28%;
      .transform-text {
        position: absolute;
        font-size: 48px;
        line-height: 48px;
      }
      .newtransform-text {
        font-size: 40px;
      }
    }
  }
}
@media (max-width: 767px) {
  .home-main {
    display: block;
    background: #fff;
    .home-main-text {
      position: relative;
      width: 100%;
      min-height: 420px;
      margin-top: 80px;
      .transform-text {
        position: absolute;
        left: -27%;
        font-size: 50px;
        line-height: 50px;
        text-align: left;
        color: #333;
        white-space: nowrap;
        transform: rotate(-90deg);
      }
      .newtransform-text {
        left: -20%;
        font-size: 35px;
      }
    }
    .home-main-pic {
      position: relative;
      width: 100%;
      min-height: 227px;
      overflow: hidden;

      .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 7%;
      }
      .down {
        position: absolute;
        bottom: 10%;
        left: 10%;
        width: 40px;
      }
    }
  }
}
</style>